import React from "react";
import { useTranslation } from "react-i18next";
import { resetModal } from "../../state/actions/modalAction";
import { useDispatch } from "react-redux";
import idExamples from "../../assets/images/id-examples.png";
import "./IdDateInfoPopup.scss";

const IdDateInfoPopup = (props: { size?: string }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(resetModal());
  };

  // useEffect(() => {
  //   const closePopupBtn = document.getElementById("close-popup-btn");
  //   closePopupBtn?.focus();
  // }, [dispatch]);

  return (
    <div className="date-info-container">
      <span className="date-info-title" id="dialogTitle">{t("IdDateInfoPopup.title")}</span>
      <img src={idExamples} alt="ids" />
      <span className="date-info-attention">
        {t("IdDateInfoPopup.attention")}
      </span>
      <span className="date-info-main-text">
        {t("IdDateInfoPopup.firstLabel")}
      </span>
      <span className="date-info-main-text">
        {t("IdDateInfoPopup.secondLabel")}
      </span>
      <span className="date-info-main-text">
        {t("IdDateInfoPopup.thirdLabel")}
      </span>
      <div className="d-flex align-items-center justify-content-center">
        <button className="date-info-button" onClick={closeModal}>
          {t("general.close")}
        </button>
      </div>
    </div>
  );
};

export default IdDateInfoPopup;
